import React, { useState } from "react";
import { Link } from "react-router-dom";
import ViewInjRom from "./ViewInjRom";
import ViewInjStrength from "./ViewInjStrength";
import ViewInjIsokinetic from "./ViewInjIsokinetic";
import ViewInjSpecial from "./ViewInjSpecial";
import ViewInjPalpation from "./ViewInjPalpation";

const InjAssessmentViewTabs = ({ details }: any) => {

    const data = JSON.parse(details);    
    
    const [activeTab, setActiveTab] = useState("Palpation");

    const tabData = [
         {
            icon: <i className="fas fa-hand-holding-medical" />,
            name: "Palpation",
            content: <ViewInjPalpation doa={data[0].dateofAssessment} pl={data[0].palpation_left} pr={data[0].palpation_right} />
        },
        {
            icon: <i className="fas fa-person-walking" />,
            name: "Range of Motion",
            content: <ViewInjRom stepData={data[0].rom} />
        },
        {
            icon: <i className="fas fa-dumbbell" />,
            name: "Strength",
            content: <ViewInjStrength stepData={data[0].strength} />
        },
        {
            icon: <i className="fas fa-wave-square" />,
            name: "Isokinetic",
            content: <ViewInjIsokinetic stepData={data[0].isokinetic} />
        },
        {
            icon: <i className="fas fa-stethoscope" />,
            name: "Special Tests",
            content: <ViewInjSpecial stepData={data[0].special} />
        }
    ]

    return (
        <>
            <div className="container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default InjAssessmentViewTabs;